<template>
    <div class="content" v-html="value" />
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            required: true
        }
    }
};
</script>
